import localization from '../localization';
import {emailRegExp, trimText} from "utils";
import {validatePhoneNum} from "../utils";

export default {
    plainAddress: {
        isValid: (name) => trimText(name).length > 1,
        message: (lang) => localization[lang].residency_errors.address
    },
    address: {
        address: {
            isValid: (name) => trimText(name).length > 1,
            message: (lang) => localization[lang].residency_errors.address
        },
        city: {
            isValid: (name) => trimText(name).length > 1,
            message: (lang) => localization[lang].residency_errors.city
        },
        state: {
            isValid: (name) => trimText(name).length > 1,
            message: (lang) => localization[lang].residency_errors.state
        },
        zip: {
            isValid: (name) => trimText(name).length > 1,
            message: (lang) => localization[lang].residency_errors.zip
        },

    },
    email: {
        isValid: (email) => emailRegExp(trimText(email)),
        message: (lang) => localization[lang].landlord_email_error
    },
    number: {
        isValid: (num) => validatePhoneNum(num),
        message: (lang) => localization[lang].common_errors.phone
    }
};
